import React from 'react';

import APPCONFIG from "constants/Config";

import Framework from "@beardeddevops/react.framework";
import {Breadcrumb, Objects} from "components";

export default class Two_Steps extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<div className="page-bar">
					<ul className="page-breadcrumb">
						<Breadcrumb name={"Two Step"} url={"/two_steps"} icon={"lock"}/>
					</ul>
				</div>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Objects.TwoStep
						id={this.props.match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={this.props.baseUrl}
					/>
				</Framework.Errors.General>
			</div>
		);
	}
}


